import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Structural Integrity Audit",
  description: "Advanced diagnostic evaluation of load-bearing systems. We utilize high-precision instrumentation to identify micro-fractures and structural fatigue in commercial roofing frameworks.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/structural_audit.png",
  link: "/TrustedInspectionsServiceAndLocationPagesPage"
}, {
  title: "Thermal Performance Scan",
  description: "High-resolution infrared thermography to detect thermal bridging and insulation deficiencies. Our technical reports provide localized data on energy loss and sub-surface anomalies.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/thermal_scan.png",
  link: "/DedicatedServiceAndLocationPagesPage"
}, {
  title: "Moisture Mitigation Analysis",
  description: "Precision moisture mapping using non-destructive electronic sensors. We pinpoint water intrusion points and saturated substrates to prevent systemic membrane failure.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/moisture_analysis.png",
  link: "/DedicatedServiceAndLocationPage"
}];
export default function CommercialRepairServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="2052" id="service-overview" className="bg-background py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={ref} className={`mb-12 text-center transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="text-foreground text-3xl font-extrabold tracking-tight sm:text-4xl">
            Technical Diagnostic & Inspection Services
          </h2>
          <p className="text-muted-foreground mt-4 text-lg font-medium leading-relaxed">
            Precision-engineered assessment protocols designed to identify vulnerabilities before they become liabilities.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {services.map((service, index) => <div key={index} data-index={index} className={`transition-all duration-700 delay-${index * 100} ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
              <Card className="bg-card/50 backdrop-blur-md border border-border hover:border-primary shadow-xl hover:shadow-2xl h-full overflow-hidden rounded-xl pt-0 transition-all duration-[400ms]">
                <div className="w-full">
                  <AspectRatio ratio={16 / 9}>
                    <img src={service.image} alt={service.title} className="h-full w-full object-cover" />
                  </AspectRatio>
                </div>
                <CardHeader className="pt-6">
                  <CardTitle className="text-foreground text-2xl font-bold tracking-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-base font-medium leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="mt-auto pb-6">
                  <Link to={service.link} className="text-primary hover:text-primary/80 group inline-flex items-center text-base font-bold transition-colors">
                    View Technical Specs
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}